<div class="modal-header">
  <h4 class="modal-title h5" translate>Contacts</h4>
  <button type="button" class="close" aria-label="Close" (click)="onClose()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body modal-contacts">
  @if (isLoading) {
    <div class="content-loading d-flex align-items-center justify-content-center py-5">
      <div class="text-center">
        <div class="mb-2 display-4 text-primary">
          <span class="fa-solid fa-spinner fa-spin"></span>
        </div>
      </div>
    </div>
  }
  @if (!isLoading) {
    <div class="row row-eq-height" >
      @for (contact of supportContacts; track contact) {
        <scitis-support-contact-item
          [contact]="contact"
          class="col-12 col-md-6 col-lg-4 my-2">
        </scitis-support-contact-item>
      }
    </div>
  }
  <!-- Fallback message -->
  @if (showFallBackText) {
    <div class="alert alert-info text-center mb-0">
      <span [innerText]="fallbackText"></span>
    </div>
  }
</div>
<scitis-modal-footer
  [okButtonText]="closeButtonText"
  [showCancelButton]="false"
  (okButtonPressed)="onClose()">
</scitis-modal-footer>
